import { Component, OnInit, signal, computed } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { SelectItem } from 'primeng/api';
import { loadEmployeeUsers } from '../../../../core/store/employee/employee.action';
import { deepClone } from '../../../../helpers/utils';
import { DateRangeModel } from '../../../../models/dateRangeModel';
import { DropdownFilterService } from '../../../../core/services/dropdown-filter.service';
import { dismissTransmission, dismissTransmissionSuccess, getPaylocityTransmissions } from '../../../../core/store/paylocity/paylocity.action';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { PaylocityTransmissionModel } from '../../../../models/paylocityTranmissionModel';
import { UserAutoCompleteItem, ModifiedSelectItem } from '../../../../models/utilModels';
import { tap } from 'rxjs';

@Component({
    selector: 'app-report-paylocity',
    templateUrl: './report-paylocity.component.html',
    styleUrls: ['./report-paylocity.component.scss'],
    standalone: false
})
export class ReportPaylocityComponent extends BaseComponent implements OnInit {
  filter: any;
  canEdit: boolean = false;
  list: PagingResultsModel<PaylocityTransmissionModel>;

  loadingPaylocityList: boolean = true;

  selectedUserEmployee: UserAutoCompleteItem;
  userEmployeeList: UserAutoCompleteItem[];
  userId: number = 0

  typeList: ModifiedSelectItem[] = [{ label: 'All', value: null }, { label: 'CREATE', value: 'CREATE' }, { label: 'UPDATE', value: 'UPDATE' }, { label: 'EARNING', value: 'EARNING' }, { label: 'DELETE EARNING', value: 'DELETE EARNING' }, { label: 'DEDUCTION', value: 'DEDUCTION' }, { label: 'DELETE DEDUCTION', value: 'DELETE DEDUCTION' }];
  transmissionType: string = null;

  dateRangeList: DateRangeModel[];
  dateRange: DateRangeModel;
  startDate: string = null;
  endDate: string = null;
  isCustomDateRange: boolean = false;

  yesNoAllOptions: SelectItem[] = [
    { label: 'All', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  hasError: boolean = null;
  dismissed: boolean = false;

  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private dropdownFilterService: DropdownFilterService  ) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canEdit = permissionIDs && !!permissionIDs.find(p => p === 3074); //Manage Paylocity
      }),
      this.store.select(s => s.employeeState.employeeUsers).subscribe(users => {
        this.userEmployeeList = users.map(x => ({
          id: x.value,
          name: x.label
        }));
      }),
      this.store.select(s => s.paylocityState.loadingTransmissions).subscribe(loading => {
        this.loadingPaylocityList = loading;
      }),
      this.store.select(s => s.paylocityState.transmissions).subscribe(list => {
        this.list = list;
        if(list != null)
     	  	  	  this.totalRecords.set(list.totalRecords);
      }),
      this.actions$.pipe(
        ofType(dismissTransmissionSuccess),
        tap(() => {
          this.reloadList(this.filter);
        })
      ).subscribe(),
    );

    this.dateRangeList = this.dropdownFilterService.getLast120DayDateRanges();
    if (this.dateRangeList && this.dateRangeList.length > 0) {
      this.dateRange = this.dateRangeList[0];
    }
  }  

  getStaffList(event) {
    this.store.dispatch(loadEmployeeUsers({
      prefixText: event.query,
      programId: null,
      payrollClassificationId: null,
      showTerminated: true,
      showInactive: true
    }));
  }

  changedDateRange() {
    if (this.dateRange.isCustom) {
      this.isCustomDateRange = true;
      return; //reload after manually changing date
    }

    this.isCustomDateRange = false;
    this.startDate = this.dateRange.startDate;
    this.endDate = this.dateRange.endDate;
    this.reloadList(this.filter);
  }

  reloadListAfterStaffChage(selectedUser) {
    if (typeof selectedUser.value.id !== 'number') {
      return;
    }

    this.userId = selectedUser.value.id;
    this.reloadList(this.filter);
  }

  reloadListAfterClear(event) {    

    this.userId = 0;
    this.reloadList(this.filter);
  }

  reloadList(event) {    
    this.filter = event;
    this.filter = deepClone(this.filter);
    this.filter.filters.userId = { Name: 'userId', Value: { value: this.userId.toString() } };
    this.filter.filters.transmissionType = { Name: 'transmissionType', Value: { value: this.transmissionType } };
    this.filter.filters.startDate = { Name: 'startDate', Value: { value: this.startDate } };
    this.filter.filters.endDate = { Name: 'endDate', Value: { value: this.endDate } };
    this.filter.filters.hasError = { Name: 'hasError', Value: { value: this.hasError } };
    this.filter.filters.dismissed = { Name: 'dismissed', Value: { value: this.dismissed } };

    this.store.dispatch(getPaylocityTransmissions({
      filter: this.filter
    }));
  }

  dismissTransmission(transmission: PaylocityTransmissionModel) {
    if (typeof transmission === 'undefined' || transmission === null) {
      //display error
      return;
    }

    this.store.dispatch(dismissTransmission({transmission}));
  }

}
